import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import { Accordion, Form, Row, Col, Collapse, Button, Modal } from "react-bootstrap";
import CombosAnidados from "../../components/combosAnidados/combosAnidadosTomo2";
import { INFO, ALERT_ERROR } from "../../components/iconsSVG/IconsSVG";
import {
  getModalidadesTomo2,
} from "../../services/sumarioService";
import { getBuscarAnotaciones, getBuscarAnotacionesTotales } from '../../services/buscarTomos';
import BusquedaTomos from "./components/botonesBusquedaTomos";
import DropDownBuble from "../../components/dropdownbuble/DropDownBuble";
// import { AlertComp } from "../FormularioPage/components/alert/alertComp";

import { useAlert } from "../../context/AlertContext";

const BuscadorAvanzadoTomo2 = forwardRef(({ onResultados, setCargando2, setBusquedaRealizada2, onSearchData, resultadosTotales }, ref) => {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  const [showModalModalidades, setShowModalModalidades] = useState(false);
  const handleCloseModalModalidades = () => setShowModalModalidades(false);
  const handleShowModalModalidades = () => setShowModalModalidades(true);

  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [modalidad, setModalidad] = useState("");
  const [numeroSolicitud, setNumeroSolicitud] = useState("");
  const [numeroPublicacion, setNumeroPublicacion] = useState("");
  const [fechaPublicacionDesde, setFechaPublicacionDesde] = useState("");
  const [fechaPublicacionHasta, setFechaPublicacionHasta] = useState("");
  const [solicitanteTitular, setSolicitanteTitular] = useState("");
  const [inventor, setInventor] = useState("");
  const [agenteRepresentante, setAgenteRepresentante] = useState("");
  const [codigoAgente, setCodigoAgente] = useState("");
  const [recurrente, setRecurrente] = useState("");
  const [numeroPrioridad, setNumeroPrioridad] = useState("");
  const [fechaPrioridad, setFechaPrioridad] = useState("");
  const [clasificacionCIP, setClasificacionCIP] = useState("");


  const [modalidades, setModalidades] = useState([]);
  const [selectedModalidadId, setSelectedModalidadId] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const combosAnidadosRef = React.createRef();
  const [capitulo, setCapitulo] = useState("");
  const [subcapitulo, setSubcapitulo] = useState("");
  const [apartado, setApartado] = useState("");
  const [subapartado, setSubapartado] = useState("");
  const [ley, setLey] = useState("");
  const inputRefDesde = useRef(null);
  const inputRefHasta = useRef(null);
  const inputRefPrioridad = useRef(null);
  const [accordionKey, setAccordionKey] = useState("1");

  // const [mostrarAlert, setmostrarAlert] = useState(false);
  // const [tipo, setTipo] = useState("");
  // const [titulo, setTitulo] = useState("");
  // const [msg, setMsg] = useState("");
  // const [customIcon, setCustomicon] = useState(null);

  // const handleCloseAlert = () => {
  //   setmostrarAlert(false);
  // };

  const toggleFilters = () => {
    setOpen(!open);
  };

  const limpiarCampos = () => {

    if (combosAnidadosRef.current) {
      combosAnidadosRef.current.resetCapituloId();
      
      setBusquedaRealizada2(false)
    }

    setTextoBusqueda("");
    setModalidad("");
    setNumeroSolicitud("");
    setNumeroPublicacion("");
    setFechaPublicacionDesde("");
    setFechaPublicacionHasta("");
    setSolicitanteTitular("");
    setInventor("");
    setAgenteRepresentante("");
    setCodigoAgente("");
    setRecurrente("");
    setNumeroPrioridad("");
    setFechaPrioridad("");
    setClasificacionCIP("");
    setSelectedModalidadId("");
    // setmostrarAlert(false);

    closeAlert();

    // setCargando2(false);

  };

  useImperativeHandle(ref, () => ({
    limpiarCampos: limpiarCampos,
  }));


  useEffect(() => {
    const fetchModalidades = async () => {
      const modalidadesList = await getModalidadesTomo2();
      const arrayTransformado = Object.entries(modalidadesList || {}).map(([id, displayName]) => ({
        id: parseInt(id, 10), // Aseguramos que el ID sea un número
        displayName,
      }));
      setModalidades(arrayTransformado);
      setSelectedModalidadId("");
    };
    fetchModalidades();
  }, []);

  const handleCombosAnidadosT2 = (capitulo, subcapitulo, apartado, subapartado, ley) => {
    setCapitulo(capitulo);
    setLey(ley);
    setSubcapitulo(subcapitulo);
    setApartado(apartado);
    setSubapartado(subapartado);
  };

    const { showAlert } = useAlert();
    const { closeAlert } = useAlert();

    const handleSearchT2 = () => {

    const searchData = {
      tomo:2,
      textoBusqueda,
      numeroSolicitud,
      numeroPublicacion,
      fechaPublicacionDesde,
      fechaPublicacionHasta,
      solicitanteTitular,
      inventor,
      agenteRepresentante,
      codigoAgente,
      recurrente,
      numeroPrioridad,
      fechaPrioridad,
      clasificacionCIP,
      capitulo,
      subcapitulo,
      apartado,
      subapartado,
      ley,
      selectedModalidadId,
    };

    if (textoBusqueda == "" && numeroSolicitud == "" && numeroPublicacion == "" && fechaPublicacionDesde == "" 
      && fechaPublicacionHasta == "" && solicitanteTitular == "" && inventor == "" && agenteRepresentante == "" 
      && codigoAgente == "" && recurrente == "" && numeroPrioridad == "" && fechaPrioridad == "" 
      && clasificacionCIP == "" && selectedModalidadId == "" && capitulo == "" && subcapitulo == "" 
      && apartado == "" && subapartado == "" && ley == "" ) {
      //setShow(true);
      // setTipo("error");
      // setTitulo("");
      // setMsg("Se debe introducir al menos un parámetro de búsqueda.");
      
      // setCustomicon(<ALERT_ERROR/>)
      // setmostrarAlert(false);
      // setmostrarAlert(true);
      
            showAlert({
              tipo: "error",
              titulo: "",
              msg: "Se debe introducir al menos un parámetro de búsqueda.",
              customIcon: <ALERT_ERROR/>
            });

      window.scrollTo(0, 250);
    } else {
      try {
        // setmostrarAlert(false);
        closeAlert();
        setAccordionKey(null);
        setCargando2(true);
        setBusquedaRealizada2(false);
        // Llamada al servicio
        const fetchAnotaciones = async () => { 
          onResultados([]);
          resultadosTotales(null);
          await new Promise(resolve => setTimeout(resolve, 2000)); // espero 2 segundos
          const resultadoBusqueda = await getBuscarAnotaciones(searchData, 0, 20, "", 0);
          const totalBusqueda = await getBuscarAnotacionesTotales(searchData);
          onResultados(resultadoBusqueda);
          setBusquedaRealizada2(true);
          setCargando2(false);
          onSearchData(searchData);
          resultadosTotales(totalBusqueda)
        };
        fetchAnotaciones();
      } catch (error) {
        setCargando2(false);
        setBusquedaRealizada2(true); // búsqueda realizada aunque ha habido error
        console.error('Error al hacer la búsqueda: ', error);
      }

    }
  };


  return (
    <>
      <div className="espacios-generales shadow m-0 p-0">
        {/* <div className="center"> */}
        {/* <Button
          className="btn-azul"
          onClick={toggleFilters}
          aria-controls="filtrosCollapse"
          aria-expanded={open}
        > */}
        <Accordion activeKey={accordionKey} onSelect={(k) => setAccordionKey(k)} className="w-100 glob-custom-accordion-button" style={{ zIndex: "3000" }}>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Filtros de búsqueda
            </Accordion.Header>
            <Accordion.Body>
              {/* {open ? "Ocultar filtros de búsqueda" : "Mostrar filtros de búsqueda"}
            </Button>
            <Collapse in={open}> */}
              <div id="filtrosCollapse" className="text-start">
                <Form onSubmit={(e) => { e.preventDefault(); handleSearchT2(); }}
                      onKeyDown={(e) => { if (e.key === "Enter") {e.preventDefault(); handleSearchT2(); }}}>
                  {/* { mostrarAlert ? <AlertComp tipo={tipo} titulo={titulo} msg={msg} customIcon={customIcon}></AlertComp> : null } */}
                  {/* {mostrarAlert && (
                    <AlertComp 
                      tipo={tipo} 
                      titulo={titulo} 
                      msg={msg} 
                      customIcon={customIcon}   
                      open={mostrarAlert}
                      onClose={handleCloseAlert}
                    />
                  )} */}
                  <br />
                  <p>
                    Puedes buscar cualquier publicación en el Boletín Oficial de la
                    Propiedad Industrial Tomo 2 por los siguientes campos.
                  </p>
                  <br />

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label className="text-start">
                        <b>Texto de búsqueda</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Texto de búsqueda"
                        value={textoBusqueda}
                        onChange={(e) => setTextoBusqueda(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Modalidad</b>
                        <Button className="fondo-blanco-icono" onClick={handleShowModalModalidades}>
                          {/* <INFO color_icono="#203C77" color_fondo="white" class="p-0 m-0" /> */}
                        </Button>
                        <Modal show={showModalModalidades} onHide={handleCloseModalModalidades}>
                          <Modal.Header closeButton></Modal.Header>
                          <Modal.Body>Modalidad: Lista con los tipos de modalidades de Invenciones.</Modal.Body>
                        </Modal>
                      </Form.Label>
                      <Form.Select
                        className="mb-3"
                        // as="select"
                        value={selectedModalidadId}
                        onChange={(e) => setSelectedModalidadId(e.target.value)}
                      >
                        <option value="">Seleccione una modalidad</option>
                        {modalidades.map((modalidad) => (
                          <option key={modalidad.id} value={modalidad.id}>
                            {modalidad.displayName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Número de solicitud</b>
                      </Form.Label>
                      <Form.Control
                        className="mb-3"
                        type="text"
                        placeholder="Número de solicitud"
                        value={numeroSolicitud}
                        // onChange={(e) => setNumeroSolicitud(e.target.value)}
                        // Se borran espacios al principio y al final
                        onChange={(e) => setNumeroSolicitud(e.target.value.replace(/^\s+|\s+$/g, ''))}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label>
                        <b>Número de publicación</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Número de publicación"
                        value={numeroPublicacion}
                        onChange={(e) => setNumeroPublicacion(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label>
                        <b>Fecha de publicación desde</b>
                      </Form.Label>
                      <Form.Control
                        ref={inputRefDesde}
                        className="mb-3 date-picker-only"
                        type="date"
                        value={fechaPublicacionDesde}
                        onChange={(e) => setFechaPublicacionDesde(e.target.value)}
                        min="1984-02-10"
                        max={new Date().toISOString().split('T')[0]}
                        onKeyDown={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onClick={() => inputRefDesde.current?.showPicker()}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Fecha de publicación hasta</b>
                      </Form.Label>
                      <Form.Control
                        ref={inputRefHasta}
                        className="mb-3 date-picker-only"
                        type="date"
                        defaultValue={getCurrentDate()}
                        value={fechaPublicacionHasta}
                        onChange={(e) => setFechaPublicacionHasta(e.target.value)}
                        min="1984-02-10"
                        max={new Date().toISOString().split('T')[0]}
                        onKeyDown={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onClick={() => inputRefHasta.current?.showPicker()}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label className="text-start text-break">
                        <b>Solicitante/Titular</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Solicitante/Titular"
                        value={solicitanteTitular}
                        onChange={(e) => setSolicitanteTitular(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label>
                        <b>Inventor</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Inventor"
                        value={inventor}
                        onChange={(e) => setInventor(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label className="text-start text-break">
                        <b>Agente/Representante</b>
                        <Button className="m-0 p-0 fondo-blanco-icono info invisible">
                            <INFO color_icono="#203C77" color_fondo="transparent" className="p-0 m-0" />
                        </Button>
                      </Form.Label>
                      <Form.Control
                        className="mb-3"
                        type="text"
                        placeholder="Agente/Representante"
                        value={agenteRepresentante}
                        onChange={(e) => setAgenteRepresentante(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Código agente</b>
                        <Button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          className="m-0 p-0 fondo-blanco-icono info"
                          onClick={() => window.open("https://www.oepm.es/es/conoce-la-propiedad-industrial/informacion-general/quienes-pueden-asesorarnos-y-ayudarnos-a-gestionar-los-tramites/buscador-de-agentes/", "_blank", "noopener,noreferrer")}
                        >
                          <INFO color_icono="#203C77" color_fondo="transparent" className="p-0 m-0" />
                        </Button>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="0000"
                        style={{ width: "10ch"}}
                        value={codigoAgente}
                        onChange={(e) => {
                          const soloNumeros = e.target.value.replace(/\D/g, "").slice(0, 4);
                          setCodigoAgente(soloNumeros)}}
                                                  
                        onBlur={() => {
                          if (codigoAgente) {
                            setCodigoAgente(codigoAgente.padStart(4, "0"));
                          }
                        }}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label className="text-start">
                        <b>Recurrente</b>
                        <Button className="fondo-blanco-icono" onClick={handleShow}>
                          {/* <INFO color_icono="#203C77" color_fondo="white" class="p-0 m-0" /> */}
                        </Button>
                        <Modal show={show} onHide={handleClose}>
                          <Modal.Header closeButton></Modal.Header>
                          <Modal.Body>Información sobre recurrente</Modal.Body>
                        </Modal>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Recurrente"
                        value={recurrente}
                        onChange={(e) => setRecurrente(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Nº de prioridad</b>
                      </Form.Label>
                      <Form.Control
                        className="mb-3"
                        type="text"
                        placeholder="Nº de prioridad"
                        value={numeroPrioridad}
                        onChange={(e) => setNumeroPrioridad(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label>
                        <b>Fecha de prioridad</b>
                      </Form.Label>
                      <Form.Control
                        ref={inputRefPrioridad}
                        className="mb-3 date-picker-only"
                        type="date"
                        value={fechaPrioridad}
                        onChange={(e) => setFechaPrioridad(e.target.value)}
                        max={new Date().toISOString().split('T')[0]}
                        onKeyDown={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onClick={() => inputRefPrioridad.current?.showPicker()}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Clasificación CIP</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Clasificación CIP"
                        value={clasificacionCIP}
                        onChange={(e) => setClasificacionCIP(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={12}>
                      <CombosAnidados ref={combosAnidadosRef} combosAnidadosT2={handleCombosAnidadosT2} />
                    </Form.Group>
                  </Row>
                  <button type="submit" style={{ display: "none" }} />
                </Form>
              </div>
              {/* </Collapse> */}

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {accordionKey === "1" && (
          <div className="d-flex flex-row justify-content-center">
            <BusquedaTomos
              onSearch={handleSearchT2} 
              onLimpiarFiltros={limpiarCampos}
            />
            <br />
            <DropDownBuble
              tomo="Tomo1"
              onRecargarResultados={handleSearchT2}
              onLimpiarFiltros={limpiarCampos}
            />
          </div>
        )}
      </div>
            
      <br />
    </>
  );
});

const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  return `${year}-${month}-${day}`;
};

export default BuscadorAvanzadoTomo2;
